/** Short listing description shown in the Chisme app. */
export const BUSINESS_DESCRIPTION_MAX_LENGTH = 300;
